var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 19,
    viewBox: "0 0 6 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0C2.40326 0 1.83097 0.22242 1.40901 0.61833C0.987053 1.01424 0.75 1.55121 0.75 2.11111C0.75 2.67101 0.987053 3.20798 1.40901 3.60389C1.83097 3.9998 2.40326 4.22222 3 4.22222C3.59674 4.22222 4.16903 3.9998 4.59099 3.60389C5.01295 3.20798 5.25 2.67101 5.25 2.11111C5.25 1.55121 5.01295 1.01424 4.59099 0.61833C4.16903 0.22242 3.59674 0 3 0ZM0 7.03704V8.44444H0.75H1.5V17.5926H0.75H0V19H0.75H1.5H4.5H5.25H6V17.5926H5.25H4.5V7.03704H3.75H0.75H0Z",
    fill: "#476355"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.eda64f476928bd6c1aa34646a6ee7f8b.svg";
export { ForwardRef as ReactComponent };